<div class="row" *ngFor="let item of customfields" [ngSwitch]="true">


  <div class="col-sm-12" *ngSwitchDefault>
    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <input type="text" [readOnly]="!editionEnabled" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" [(ngModel)]="item.value" >
    </div>
  </div>
  <div class="col-sm-12" *ngSwitchCase="item.type === 'textarea'">
    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <textarea  [readOnly]="!editionEnabled" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" [(ngModel)]="item.value" ></textarea>
    </div>
  </div>
  <div class="col-sm-12" *ngSwitchCase="item.type === 'number'">
    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <input  [readOnly]="!editionEnabled" type="number" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" [(ngModel)]="item.value" >
    </div>
  </div>

  <div class="col-sm-12" *ngSwitchCase="item.type === 'picture'">
    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <div *ngIf="item.imagen != ''"><img [src]="item.imagenth"  class="image"  (click)="open(item.imagen)"></div>
      <input  [readOnly]="!editionEnabled" type="file" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" (change)="actualizarImagen($event.target.files,item)"/>

    </div>
  </div>
  <div class="col-sm-12" *ngSwitchCase="item.type === 'select' || item.type === 'user_list' || item.type === 'product_list' || item.type === 'region_list'  || item.type === 'field_list' || item.type === 'machinery_list'">
    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <ng-multiselect-dropdown *ngIf="editionEnabled" [ngClass]="item.multiple === true ? 'multi-selection' : 'single-selection'"
        [placeholder]="item.title"
        [settings]="item.multiple === true ? dropdownSettings : dropdownSettingsSingle"
        [data]="item.elements"
        [(ngModel)]="item.value"
      >
      </ng-multiselect-dropdown>
      <input type="text" *ngIf="!editionEnabled" readOnly="true" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" [(ngModel)]="item.value" >
    </div>
  </div>
  <div class="col-sm-12" *ngSwitchCase="item.type === 'customentity_list'">


    <ngx-custom-entity-field [editionEnabled]="editionEnabled" [fieldProperties]="item" (onChangeValue)="onCustomEntityChangeValue($event)"></ngx-custom-entity-field>
</div>

<div class="col-sm-12" *ngSwitchCase="item.type === 'subform'">


  <ngx-subform #subformInstance [editionEnabled]="editionEnabled" [loadSubform]="item" [subformTitle]="item.title" ></ngx-subform>
</div>


  <div class="col-sm-12" *ngSwitchCase="item.type === 'radio'">
    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <nb-radio-group [disabled]="!editionEnabled" name="{{item.key}}" [(ngModel)]="item.value">
        <nb-radio
          *ngFor="let it of item.elements"
          [value]="it">
          {{ it }}
        </nb-radio>
      </nb-radio-group>
    </div>
  </div>

  <div class="col-sm-12" *ngSwitchCase="item.type === 'checkbox'">
    <div class="form-group">

        <label for="{{item.key}}" class="label">{{item.title}}</label>
        <nb-select name="{{item.key}}" [placeholder]="item.title" fullWidth name="role" [(ngModel)]="item.value" [disabled]="!editionEnabled">
          <nb-option [value]="true">Sí</nb-option>
          <nb-option [value]="false">No</nb-option>
        </nb-select>
    </div>
  </div>

<div class="col-sm-12" *ngSwitchCase="item.type === 'date_range'">
  <div class="row">
  <div class="col-sm-6" >
    <div class="form-group">
      <label for="{{item.key}}desde" class="label">{{item.title}}</label>
      <input *ngIf="!editionEnabled" readonly="true" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" value="{{formatDate(item.value.from,'YYYY/MM/DD')}}">
      <input *ngIf="editionEnabled" [nbDatepicker]="editionEnabled ? datepickerfrom : null" type="text" nbInput fullWidth id="{{item.key}}desde" name="{{item.key}}desde" [(ngModel)]="item.value.from" >
      <nb-datepicker #datepickerfrom format="yyyy/MM/dd"></nb-datepicker>
    </div>
  </div>
  <div class="col-sm-6" >
    <div class="form-group">
      <label for="{{item.key}}desde" class="label">Hasta</label>
      <input *ngIf="!editionEnabled" readonly="true" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" value="{{formatDate(item.value.to,'YYYY/MM/DD')}}">
      <input *ngIf="editionEnabled" [nbDatepicker]="editionEnabled ?datepickerto : null" type="text" nbInput fullWidth id="{{item.key}}hasta" name="{{item.key}}hasta" [(ngModel)]="item.value.to" >
      <nb-datepicker #datepickerto format="yyyy/MM/dd"></nb-datepicker>
    </div>
  </div>
  </div>
</div>

<div class="col-sm-12" *ngSwitchCase="item.type === 'datetime_range'">
  <div class="row">
  <div class="col-sm-6" >
    <div class="form-group">
      <label for="{{item.key}}desde" class="label">{{item.title}}</label>
      <input *ngIf="!editionEnabled" readonly="true" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" value="{{formatDate(item.value.from,'YYYY/MM/DD HH:mm:ss')}}">
      <input *ngIf="editionEnabled" [nbDatepicker]="editionEnabled ? datetimepickerfrom : null" type="text" nbInput fullWidth id="{{item.key}}desde" name="{{item.key}}desde" [(ngModel)]="item.value.from" >
      <nb-date-timepicker withSeconds #datetimepickerfrom format="yyyy/MM/dd HH:mm:ss"></nb-date-timepicker>
    </div>
  </div>
  <div class="col-sm-6" >
    <div class="form-group">
      <label for="{{item.key}}desde" class="label">Hasta</label>
      <input *ngIf="!editionEnabled" readonly="true" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" value="{{formatDate(item.value.to,'YYYY/MM/DD HH:mm:ss')}}">
      <input *ngIf="editionEnabled" [nbDatepicker]="editionEnabled ? datetimepickerto : null" type="text" nbInput fullWidth id="{{item.key}}hasta" name="{{item.key}}hasta" [(ngModel)]="item.value.to" >
      <nb-date-timepicker withSeconds #datetimepickerto format="yyyy/MM/dd HH:mm:ss"></nb-date-timepicker>
    </div>
  </div>
  </div>
</div>

<div class="col-sm-12" *ngSwitchCase="item.type === 'date'">

    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <input *ngIf="!editionEnabled" readonly="true" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" value="{{formatDate(item.value,'YYYY/MM/DD')}}">
      <input *ngIf="editionEnabled"[nbDatepicker]="editionEnabled ? datepicker : null" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" [(ngModel)]="item.value" >
      <nb-datepicker #datepicker format="yyyy/MM/dd"></nb-datepicker>
    </div>
  </div>

  <div class="col-sm-12" *ngSwitchCase="item.type === 'datetime'">

    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <input *ngIf="!editionEnabled" readonly="true" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" value="{{formatDate(item.value,'YYYY/MM/DD HH:mm:ss')}}">
      <input *ngIf="editionEnabled" [nbDatepicker]="editionEnabled ? datetimepicker : null" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" [(ngModel)]="item.value" >
      <nb-date-timepicker withSeconds #datetimepicker format="yyyy/MM/dd HH:mm:ss"></nb-date-timepicker>
    </div>
  </div>

  <div class="col-sm-12" *ngSwitchCase="item.type === 'hour'">

    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <input *ngIf="!editionEnabled" readonly="true" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" value="{{formatDate(item.value,'HH:mm:ss')}}">
      <input *ngIf="editionEnabled" [nbTimepicker]="timepicker2" nbInput fullWidth id="{{item.key}}" name="{{item.key}}" [(ngModel)]="item.value" >

      <nb-timepicker withSeconds #timepicker2 format="HH:mm:ss"></nb-timepicker>


    </div>
  </div>

  <div class="col-sm-12" *ngSwitchCase="item.type === 'location' && subform">

    <div class="form-group">
      <label for="{{item.key}}" class="label">{{item.title}}</label>
      <div class="geometry-container">
        <button  *ngIf="editionEnabled" class="geometry-btn" nbButton size="small" status="primary" (click)="editGeometry(item.key)"><nb-icon icon="edit-outline"></nb-icon> Editar</button>
        <div  class="panel-body map-container" #geometrymapcontainer></div>

      </div>

    </div>

  </div>


</div>
